(() => {
  const initVideo = (root = document) => {
    root.querySelectorAll('.arley-hero__video').forEach(video => {
      if (video.dataset.arleyLoopReady) return;
      video.dataset.arleyLoopReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('tabindex', '-1');
      video.removeAttribute('controls');
      const hero = video.closest('.arley-hero');
      const showPoster = () => {
        if (!hero || !video.poster || !video.paused) return;
        if (!hero.querySelector('.arley-hero__autoplay-fallback')) {
          const image = new Image();
          image.className = 'arley-hero__image arley-hero__autoplay-fallback';
          image.src = video.poster;
          image.alt = '';
          image.setAttribute('aria-hidden', 'true');
          image.style.objectPosition = getComputedStyle(video).objectPosition;
          hero.insertBefore(image, video);
        }
        hero.classList.add('arley-hero--autoplay-blocked');
      };
      video.addEventListener('playing', () => hero?.classList.remove('arley-hero--autoplay-blocked'));
      const play = () => { if (!document.hidden && video.paused) video.play()?.catch(showPoster); };
      play();
      video.addEventListener('loadeddata', play, { once: true });
      document.addEventListener('visibilitychange', play);
      // Safari may block autoplay in Low Power Mode. Retry after the first real interaction.
      document.addEventListener('touchstart', play, { once: true, passive: true });
      document.addEventListener('pointerdown', play, { once: true, passive: true });
    });
  };
  initVideo();
  document.addEventListener('shopify:section:load', e => initVideo(e.target));

  const bar = document.querySelector('[data-arley-sticky-cart]');
  const root = document.querySelector('main product-info[id^="MainProduct-"]');
  const drawer = document.querySelector('cart-drawer');
  const button = bar?.querySelector('[data-arley-sticky-add]');
  const label = bar?.querySelector('[data-arley-sticky-label]');
  const price = bar?.querySelector('[data-arley-sticky-price]');
  let queued = false;
  let chatMode;
  const primary = () => root?.querySelector('.product__info-container product-form button[name="add"]');
  function sync() {
    queued = false;
    const overlay = !!drawer?.classList.contains('active') || !!document.querySelector('quick-add-modal[open], product-modal[open]');
    document.body.classList.toggle('arley-cart-overlay-open', overlay);
    if (!bar || !root) return;
    const original = primary();
    if (!original) { bar.hidden = true; document.body.classList.remove('arley-sticky-visible'); return; }
    const busy = original.classList.contains('loading');
    const disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
    button.disabled = disabled || busy;
    button.setAttribute('aria-busy', String(busy));
    label.textContent = busy ? 'WIRD HINZUGEFÜGT…' : disabled ? (original.querySelector('span')?.textContent.trim() || 'NICHT VERFÜGBAR') : 'IN DEN WARENKORB';
    const priceBox = root.querySelector('[id^="price-"] .price');
    const selectedPrice = priceBox?.querySelector(priceBox.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
    if (selectedPrice) price.textContent = selectedPrice.textContent.trim();
    const chatOpen = !!chatMode && !chatMode.classList.contains('state-resting') && !chatMode.classList.contains('state-minimized');
    const visible = original.getBoundingClientRect().bottom < 0 && !overlay && !chatOpen;
    bar.hidden = !visible;
    document.body.classList.toggle('arley-sticky-visible', visible);
    if (visible) document.body.style.setProperty('--arley-sticky-height', `${bar.offsetHeight}px`);
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
  button?.addEventListener('click', () => {
    const original = primary();
    if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
    // Delegate to the real form: selected variant, quantity, validation, analytics and drawer stay intact.
    original.click();
    schedule();
  });
  root && new MutationObserver(() => {
    const error = root.querySelector('.product-form__error-message-wrapper:not([hidden])');
    if (error?.textContent.trim()) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    schedule();
  }).observe(root, { attributes: true, childList: true, characterData: true, subtree: true });
  drawer && new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  function bindChat() {
    const next = document.querySelector('#chatty-ai-mode-root .chatty-ai-mode');
    if (next && next !== chatMode) {
      chatMode = next;
      new MutationObserver(schedule).observe(chatMode, { attributes: true, attributeFilter: ['class'] });
      schedule();
    }
  }
  // The app loads asynchronously and may replace its root after navigation.
  new MutationObserver(bindChat).observe(document.body, { childList: true, subtree: true });
  bindChat();
  sync();
})();
